module.exports = __webpack_public_path__ + "img/renewable-energy.22d0ec5d.svg";